const getters = {
  userBase: state => state.user.userBase
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js